import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, ButtonToolbar, Modal } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { withToastManager } from 'react-toast-notifications';
import { DataTable, Loading } from '../../components';
import APIClient from '../../services/APIClient';
import UIUtils from '../UIUtils';
import { connect } from 'react-redux'

class ResourceList extends React.Component {
  static propTypes = {
    toastManager: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      allSelected: false,
      isDataLoading: true,
      resources: [],
      selectedLista: [],
      selectedResource: [],
      estados: [
        { active: true, state: 'Activo' },
        { active: false, state: 'Inactivo' },
      ],
    };

    this.loadResources = this.loadResources.bind(this);
  }

  getPermissions(){
    const {isSuperAdmin, editPermission,deletePermission,isPermissionsLoading} = this.props.permissionsUser;
    this.setState({
      isSuperAdmin,
      editPermission,
      deletePermission,
      isPermissionsLoading,
    })
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.permissionsUser !== this.props.permissionsUser) {
      this.getPermissions();
    }
  }
  

  componentDidMount() {
    this.loadResources();
  }

  showDeleteConfirmModal = (row) => {
    this.setState({
      selectedResource: row,
      showConfirmModal: true,
    });
  };

  renderDeleteResourceModal = () => {
    const { showConfirmModal } = this.state;
    const selectedDetalle = {};
    return (
      <Modal size="md" show={showConfirmModal} onHide={() => this.setState({ showConfirmModal: false })}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Recurso de Planta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro de que desea eliminar y deshacer este Recurso de Planta?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={this.onConfirmDelete}>
            Eliminar
          </Button>
          <Button variant="secondary" onClick={() => this.setState({ showConfirmModal: false, selectedDetalle })}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  onConfirmDelete = async () => {
    const { selectedResource } = this.state;
    const { toastManager } = this.props;

    try {
      await APIClient.delete(`/resources/${selectedResource.id}`);
      this.setState((prevState) => {
        const resources = [...prevState.resources];
        const selectedIndex = resources.findIndex((ent) => selectedResource.id === ent.id);
        resources.splice(selectedIndex, 1);
        return { resources, selectedResource: {}, showConfirmModal: false };
      });
      toastManager.add('Recurso de Planta eliminado con éxito', {
        appearance: 'success',
      });
    } catch (err) {
      console.error(err);
      toastManager.add(`Ocurrió un error: "${err.message}"`, {
        appearance: 'error',
      });
      this.setState({ selectedResource: {}, showConfirmModal: false });
    }
  };

  onTableRef = (props) => {
    this.tableRef = props;
  };

  onLoadForm = async () => {
    const resourceRes = await APIClient.get('/resources');
    this.setState({ resources: resourceRes.data.data });
  };

  async loadResources() {
    const { toastManager } = this.props;

    try {
      const resourceRes = await APIClient.get('/resources');
      this.setState({
        resources: resourceRes.data.data,
      });
    } catch (err) {
      this.setState({ isDataLoading: false });
      console.error(err);
      toastManager.add(`Ocurrió un error: "${err.message}"`, {
        appearance: 'error',
      });
    } finally {
      this.setState({
        isDataLoading: false,
      });
    }
  }

  render() {
    const { resources, isDataLoading, estados, isSuperAdmin, editPermission, deletePermission, isPermissionsLoading } = this.state;

    const columns = [
      {
        dataField: 'id',
        text: 'ID',
        sort: true,
      },
      {
        dataField: 'description',
        text: 'Descripcion',
        sort: true,
      },
      {
        dataField: 'typeResource.description',
        text: 'Tipo',
        sort: true,
      },
      {
        dataField: 'availability',
        text: 'Disponibilidad(Hs)',
        sort: true,
      },
      {
        dataField: 'isActive',
        text: 'Estado',
        sort: true,
        formatter: (cellContent, row) => {
          if (cellContent === null) {
            return '';
          }
          const estadoFound = estados.find((estado) => cellContent === estado.active);
          const estado = estadoFound ? estadoFound.state : row.estado.state;
          return UIUtils.getClienteEstadoBadge(estado);
        },
      },
      {
        dataField: 'actions',
        isDummyField: true,
        text: '',
        formatter: (cellContent, row) => (
          <ButtonToolbar className="justify-content-center">
            <ButtonGroup>
              {isSuperAdmin || editPermission ? (
                <>
                  <LinkContainer to={`/resources/${row.id}`}>
                    <Button size="sm" variant="outline-primary" title="Editar">
                      <FontAwesomeIcon icon={faEdit} fixedWidth size="xs" />
                    </Button>
                  </LinkContainer>
                </>
              ) : (
                <></>
              )}
            </ButtonGroup>
            <ButtonGroup>
              {isSuperAdmin || deletePermission ? (
                <>
                  <Button size="sm" variant="outline-primary" title="Eliminar" onClick={() => this.showDeleteConfirmModal(row)}>
                    <FontAwesomeIcon icon={faTrashAlt} fixedWidth size="xs" />
                  </Button>
                </>
              ) : (
                <></>
              )}
            </ButtonGroup>
          </ButtonToolbar>
        ),
      },
    ];
    return (
      <div>
        <h1 className="page-title">Recursos de Planta</h1>
        {this.renderDeleteResourceModal()}
        {isPermissionsLoading === false ? (
          <DataTable
            isDataLoading={isDataLoading}
            columns={columns}
            data={resources}
            keyField="id"
            addButton={isSuperAdmin || editPermission ? '/resources/new' : null}
            showExport={false}
          />
        ) : (
          <Loading />
        )}
      </div>
    );
  }
}

const mapStateToProps = (permissionsUser) => (permissionsUser);

export default connect(mapStateToProps)(withToastManager(ResourceList));


